// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1MemorySpec
 */
export interface V1MemorySpec {
  /**
   *
   * @type {boolean}
   * @memberof V1MemorySpec
   */
  packingEfficiency?: boolean;
  /**
   *
   * @type {string}
   * @memberof V1MemorySpec
   */
  size?: string;
}

/**
 * Check if a given object implements the V1MemorySpec interface.
 */
export function instanceOfV1MemorySpec(value: object): value is V1MemorySpec {
  return true;
}

export function V1MemorySpecFromJSON(json: any): V1MemorySpec {
  return V1MemorySpecFromJSONTyped(json, false);
}

export function V1MemorySpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1MemorySpec {
  if (json == null) {
    return json;
  }
  return {
    packingEfficiency:
      json['packingEfficiency'] == null ? undefined : json['packingEfficiency'],
    size: json['size'] == null ? undefined : json['size'],
  };
}

export function V1MemorySpecToJSON(json: any): V1MemorySpec {
  return V1MemorySpecToJSONTyped(json, false);
}

export function V1MemorySpecToJSONTyped(
  value?: V1MemorySpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    packingEfficiency: value['packingEfficiency'],
    size: value['size'],
  };
}
